/*
 * @Author: Bai.Zhiming
 * @Date: 2017-8-21
 * @LastEditTime : 2020-01-10 12:36:27
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\resourceCenter\left\left.js
 * @Description:  网络资源左侧导航
 */
'use strict';
angular.module('networkSourceCenteLeftModule', []).controller('networkSourceCenteLeftCtrl', [
    '$scope',
    '$q',
    '$timeout',
    '$element',
    '$state',
    'trsHttpService',
    'resourceCenterService',
    'modalDialog',
    function($scope, $q, $timeout, $element, $state, trsHttpService, resourceCenterService, modalDialog) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                expandedLeve1: [],
                selected: '',
            };
            $scope.data = {
                share: {},
                materials: {},
                propagandaData: {},
                // propaganda: {},
                featuredResource: [
                    {
                        name: '客户端推送',
                        routerPart: 'featuredresource.push',
                    },
                    {
                        name: '机器人稿',
                        routerPart: 'featuredresource.robot',
                    },
                    {
                        name: '头条稿件',
                        routerPart: 'featuredresource.toutiao',
                    },
                ],
                classifiedresource: [
                    {
                        name: '数字报刊',
                        routerPart: 'classifiedresource.digital',
                        key: 'getSzbRoot',
                        icon: 'icon-resourcectrl-classifiedresource',
                    },
                    {
                        name: '网站',
                        routerPart: 'classifiedresource.website',
                        key: 'getWebRoot',
                        icon: 'icon-creative_distributio2',
                    },
                    {
                        name: '客户端',
                        routerPart: 'classifiedresource.app',
                        key: 'getAppRoot',
                        icon: 'icon-creative_distributio11',
                    },
                    {
                        name: '微信',
                        routerPart: 'classifiedresource.wechat',
                        key: 'getWeixinRoot',
                        icon: 'icon-creative_distributio13',
                    },
                    {
                        name: '微博',
                        routerPart: 'classifiedresource.weibo',
                        key: 'getWeiboRoot',
                        icon: 'icon-xinlangweibo',
                    },
                    {
                        name: '视频',
                        routerPart: 'classifiedresource.video',
                        key: 'tpg',
                        icon: 'icon-video', 
                    },
                    {
                        name: '图片',
                        routerPart: 'classifiedresource.picture',
                        key: 'tpg',
                        icon: 'icon-tupian2',
                    },
                ],
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            getPermissionData().then(() => {
                autoLocation();
            });
        }

        /**
         * [autoLocation description] 路由自动定位
         * @return {[type]} [description]
         */
        function autoLocation() {
            let routerName = $state.current.name;
            let routerArray = routerName.split('.');
            let timer; // 延时器
            if (routerName === 'front.networksource') {
                // 当权限数据完成，节点加载完毕，以模拟点击dom的形式，去打开加载完成的头一个节点，完成自动定位
                let $leve1 = $element.find('.leve1').eq(0);
                if ($leve1.length >= 0) {
                    let $a = $leve1.find('a').eq(0);
                    timer = $timeout(() => {
                        $a[0].click();
                        timer = $timeout(() => {
                            // 检查二级菜单，先用1秒钟，等其加载完成后，再模拟点击事件
                            let $a_child = $a.next('ul').find('li>a');
                            if ($a_child.length > 0) {
                                $a_child[0].click();
                            }
                        });
                    });
                }
            } else {
                let sign = routerArray[2];
                if (sign === 'myresources') {
                    // 我的资源
                    $scope.selectMyResourceLeve1();
                } else if (sign === 'classifiedresource') {
                    // 分类资源
                    $scope.selectClassifiedResourceLeve2(
                        $scope.data.classifiedresource.filter((item, index) => $state.current.name.indexOf(item.routerPart) >= 0)[0]
                    );
                } else if (sign === 'featuredresource') {
                    // 特色资源
                    $scope.expandLeve1('featuredresource').then(() => {
                        $scope.selectFeaturedResourceLeve2(
                            $scope.data.featuredResource.filter((item, index) => $state.current.name.indexOf(item.routerPart) >= 0)[0]
                        );
                    });
                }
            }
            $scope.$on('$destroy', () => {
                $timeout.cancel(timer);
            });
        }

        /**
         * [getPermissionData description] 获取权限数据
         * @return {[type]} [description]
         */
        function getPermissionData() {
            let deffer = $q.defer();
            let timer; // 延时器
            let params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryOperTypesBySourceModal',
                Classify: 'source',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                $scope.data.permissionData = (function() {
                    var obj = {};
                    for (var i in data) {
                        var name = data[i];
                        obj[name] = true;
                    }
                    return obj;
                })();
                timer = $timeout(() => {
                    deffer.resolve();
                });
            });
            $scope.$on('$destroy', () => {
                $timeout.cancel(timer);
            });
            return deffer.promise;
        }

        /**
         * [selectMyResourceLeve1 description] 选中一级菜单
         * @return {[type]} [description]
         */
        $scope.selectMyResourceLeve1 = function() {
            let deffer = $q.defer();
            resourceCenterService.memoryEchoOnlyLevel1('front.networksource.myresources');
            $scope.status.selected = 'myresources';
            $scope.$root.narrowNavigation = false; // 宽导航
            deffer.resolve();
            return deffer.promise;
        };

        /**
         * [selectFeaturedResourceLeve2 description] 选中特色资源的二级分类
         * @param {[object]} [item] [description] 被选中的二级分类
         * @return {[type]} [description]
         */
        $scope.selectFeaturedResourceLeve2 = function(item) {
            let deffer = $q.defer();
            getFeaturedLeve3Classify(item).then(
                () => {
                    $scope.$root.narrowNavigation = false; // 宽导航
                    deffer.resolve();
                },
                () => {
                    $scope.$root.narrowNavigation = true; // 窄导航
                    deffer.resolve();
                }
            );
            $scope.status.selected = item.routerPart;
            return deffer.promise;
        };

        /**
         * [getFeaturedClassify description] 获取特色资源的子分类
         * @param {[type]} [item] [description] 父分类信息
         * @return {[type]} [description]
         */
        function getFeaturedLeve3Classify(item) {
            let deffer = $q.defer();
            if (angular.isArray(item.value) && item.value.length > 0) {
                deffer.resolve();
            } else if (item.routerPart === 'featuredresource.push') {
                getPushClassify(item).then(
                    () => {
                        deffer.resolve();
                    },
                    () => {
                        deffer.reject();
                    }
                );
            } else if (item.routerPart === 'featuredresource.robot') {
                getRobotClassify(item).then(
                    () => {
                        deffer.resolve();
                    },
                    () => {
                        deffer.reject();
                    }
                );
            } else if (item.routerPart === 'featuredresource.toutiao') {
                getHeadClassify(item).then(
                    () => {
                        deffer.resolve();
                    },
                    () => {
                        deffer.reject();
                    }
                );
            }

            /**
             * [getPushClassify description]获取推送稿件
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            function getPushClassify(item) {
                let deffer = $q.defer();
                let params = {
                    typeid: 'zyzx',
                    serviceid: 'navigation',
                    modelid: 'getpushMedia',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(
                    (data) => {
                        if (data && angular.isArray(data.content) && data.content.length > 0) {
                            item.value = data.content;
                            deffer.resolve();
                        } else {
                            deffer.reject();
                        }
                    },
                    () => {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            }

            /**
             * [getRobotClassify description] 获取机器人稿下分类
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            function getRobotClassify(item) {
                let deffer = $q.defer();
                let params = {
                    channelName: 'jqrg',
                    containParent: false,
                    excludeId: -1,
                    level: 2,
                    modelid: 'base',
                    parentId: -1,
                    serviceid: 'navigation',
                    typeName: 'jqrg_ztfl',
                    typeid: 'zyzx',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(
                    (data) => {
                        if (angular.isArray(data) && data.length > 0) {
                            item.value = data;
                            deffer.resolve();
                        } else {
                            deffer.reject();
                        }
                    },
                    () => {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            }

            /**
             * [getHeadClassify description] 获取头条分类
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            function getHeadClassify(item) {
                let deffer = $q.defer();
                let params = {
                    typeid: 'zyzx',
                    serviceid: 'navigation',
                    modelid: 'getToutiaoRoot',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(
                    (data) => {
                        if (data && angular.isArray(data.content) && data.content.length > 0) {
                            item.value = data.content;
                            deffer.resolve();
                        } else {
                            deffer.reject();
                        }
                    },
                    () => {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            }
            return deffer.promise;
        }

        /**
         * [getFeaturedSelectedLeve2Info description] 获取特色资源选中的分类信息
         * @return {[type]} [description]
         */
        $scope.getFeaturedSelectedLeve2Info = function() {
            return $scope.data.featuredResource.filter(
                (item) => item.routerPart == $scope.status.selected && angular.isArray(item.value) && item.value.length >= 0
            )[0];
        };

        /**
         * [getFeaturedSelectedLeve2Info description] 获取特色资源选中的分类信息
         * @return {[type]} [description]
         */
        $scope.getTenantManuscriptSelectedLeve2Info = function() {
            return $scope.data.tenantManuscriptResource.filter(
                (item) => item.routerPart === $scope.status.selected && angular.isArray(item.value) && item.value.length >= 0
            )[0];
        };

        /**
         * [featuredResourceLeftShow description] 特色资源的三级菜单是否展示
         * @return {[type]} [description]
         */
        $scope.featuredResourceLeftShow = function() {
            return $scope.data.featuredResource.some(
                (item) => item.routerPart == $scope.status.selected && angular.isArray(item.value) && item.value.length > 0
            );
        };

        /**
         * [selectClassifiedResourceLeve2 description] 选择分类资源二级菜单
         * @param   {[type]}  item  [item description] 分类资源分类
         * @return  {[type]}        [return description]
         */
        $scope.selectClassifiedResourceLeve2 = function(item) {
            let deffer = $q.defer();
            (item.name === '图片' || item.name === '视频' ? getClassifiedResourcePicVideo(item) : getClassifiedResource(item)).then(
                () => {
                    $scope.$root.narrowNavigation = false; // 宽导航

                    if (item.value.length > 0) {
                        // var url = 'front.networksource.classifiedresource.digital.resource';
                        // resourceCenterService.go(url, {
                        //     medianame: item.value[0].name,
                        //     fcode: item.value[0].fcode,
                        //     param_data: item.value[0].param_data,
                        // });
                    } else {
                        deffer.resolve();
                    }
                },
                () => {
                    $scope.$root.narrowNavigation = true; // 窄导航
                    deffer.resolve();
                }
            );
            resourceCenterService.memoryEchoOnlyLevel1('front.networksource.' + item.routerPart)
            $scope.status.selected = item.routerPart;
            resourceCenterService.setSzbPage(false);
            return deffer.promise;
        };

        /**
         * [getClassifiedResource description]
         * @param {object} [item] [description] 分类资源二级分类信息
         * @return {[type]} [description]
         */
        function getClassifiedResource(item) {
            let deffer = $q.defer();
            if (item.value) {
                deffer.resolve();
                return deffer.promise;
            }
            let params = {
                typeid: 'zyzx',
                serviceid: 'navigation',
                modelId: item.key,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(
                (data) => {
                    if (data && angular.isArray(data.content) && data.content.length > 0) {
                        item.value = data.content;
                        deffer.resolve();
                    } else {
                        deffer.reject();
                    }
                },
                () => {
                    deffer.reject();
                }
            );
            return deffer.promise;
        }

        /**
         * [getMultiMediaResourceClassify description] 获取多媒体资源分类子分类信息
         * @param  {[type]} item [description] 分类信息
         * @return {[type]}      [description]
         */
        function getClassifiedResourcePicVideo(item) {
            let deffer = $q.defer();
            if (item.value) {
                deffer.resolve();
            } else {
                if (item.routerPart === 'classifiedresource.picture') {
                    getPictureClassify(item).then(
                        () => {
                            deffer.resolve();
                        },
                        () => {
                            deffer.reject();
                        }
                    );
                } else if (item.routerPart === 'classifiedresource.video') {
                    getVideoClassify(item).then(
                        () => {
                            deffer.resolve();
                        },
                        () => {
                            deffer.reject();
                        }
                    );
                }
            }

            /**
             * [getPictureClassify description] 获取图片分类信息
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            function getPictureClassify(item) {
                let deffer = $q.defer();
                let params = {
                    channelName: item.key,
                    containParent: false,
                    excludeId: -1,
                    level: 2,
                    modelid: 'base',
                    parentId: -1,
                    serviceid: 'navigation',
                    typeName: 'tp_lyzh',
                    typeid: 'zyzx',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(
                    (data) => {
                        if (angular.isArray(data) && data.length > 0) {
                            item.value = data;
                            deffer.resolve();
                        } else {
                            deffer.reject();
                        }
                    },
                    () => {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            }

            /**
             * [getVideoClassify description]
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            function getVideoClassify(item) {
                let deffer = $q.defer();
                let params = {
                    typeid: 'zyzx',
                    serviceid: 'navigation',
                    modelId: 'getWebVideoMedia',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(
                    (data) => {
                        if (angular.isArray(data) && data.length > 0) {
                            item.value = data;
                            deffer.resolve();
                        } else {
                            deffer.reject();
                        }
                    },
                    () => {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            }
            return deffer.promise;
        }

        /**
         * [getClassifiedSelectedLeve2Info description] 获取分类资源选中的分类信息
         * @return {[type]} [description]
         */
        $scope.getClassifiedSelectedLeve2Info = function() {
            return $scope.data.classifiedresource.filter(
                (item) => item.routerPart === $scope.status.selected && angular.isArray(item.value) && item.value.length > 0
            )[0];
        };

        /**
         * [getMultiMediaSelectedLeve2Info description] 获取多媒体资源选中的分类信息
         * @return {[type]} [description]
         */
        $scope.getMultiMediaSelectedLeve2Info = function() {
            return $scope.data.multiMediaResource.filter(
                (item) => item.routerPart === $scope.status.selected && angular.isArray(item.value) && item.value.length > 0
            )[0];
        };

        /**
         * [expandLeve1 description] 展开一级菜单
         * @param  {[type]} type [description] 菜单类型
         * @return {[type]}      [description]
         */
        $scope.expandLeve1 = function(type, e) {
            let deffer = $q.defer();
            if ($scope.leve1IsExpanded(type)) {
                $scope.status.expandedLeve1 = $scope.status.expandedLeve1.filter((item) => item.indexOf(type) < 0);
                deffer.resolve();
            } else {
                $scope.status.expandedLeve1.push(type);
                if (e) {
                    resourceCenterService.memoryEchoLevel1(e, 'front.networksource.' + type);
                }
                deffer.resolve();
            }
            return deffer.promise;
        };

        /**
         * [leve1IsExpanded description] 判断一级菜单是否展开
         * @param {[string]} [type] [description] 菜单类型
         * @return {[type]} [description]
         */
        $scope.leve1IsExpanded = function(type) {
            return $scope.status.expandedLeve1.some((item) => item.indexOf(type) >= 0);
        };
    },
]);
